import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  min-height: 100vh;
  background: #f4f6f7;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
`;

const Title = styled.h1`
  margin-top: 20px;
  margin-bottom: 10px;
  color: #40A4AE;
  font-size: 22px;
  text-align: center;
`;

const Subtitle = styled.p`
  margin-bottom: 20px;
  color: #333;
  font-size: 14px;
  text-align: center;
`;

const PlayerWrapper = styled.div`
  width: 100%;
  max-width: 900px;
  aspect-ratio: 16 / 9;
  background: black;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0,0,0,.25);
`;

const Iframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: 0;
`;

const FooterNote = styled.div`
  margin-top: 16px;
  font-size: 12px;
  color: #666;
  text-align: center;
`;

const SorteoEnVivo = () => {
  return (
    <Container>
           <center>
                <h1 className="botonbordeazul text-white px-5 mx-5 py-3">Transmisión en vivo del sorteo oficial
</h1>
            </center>
    

      <PlayerWrapper>
        <Iframe
          src="https://www.youtube.com/embed/MaoHty1sTOM?autoplay=1&rel=0"
          title="Sorteo en vivo"
          allow="autoplay; encrypted-media"
          allowFullScreen
        />
      </PlayerWrapper>

      <FooterNote>
        Desde este espacio podés seguir la transmisión oficial del sorteo en vivo. 
      </FooterNote>
    </Container>
  );
};

export default SorteoEnVivo;
